export default __webpack_public_path__ + "static/media/recently_active.0731a394.svg";